<template>
  <div class="row">
    <div class="col-12">
      <q-chip
        v-for="(process, idx) in assessPlan.processes"
        :key="idx"
        outline
        square
        :removable="
          editable &&
          !disabled &&
          process.ramProcessAssessStepCd !== 'RPA0000005'
        "
        :color="process.selected2 ? 'primary' : 'grey-6'"
        text-color="white"
        icon="memory"
        :selected.sync="process.selected2"
        :label="process.processName"
        :title="process.processName"
        v-model="process.check2"
        @remove="(state) => removeProcess(state, process)"
        @update:selected="(state) => selectedProcess(state, process, idx)"
      />
      <!-- 추가 -->
      <q-chip
        v-if="editable && !disabled"
        clickable
        square
        color="orange"
        text-color="white"
        icon="add"
        :label="$comm.getLangLabel('LBLADD')"
        :title="$comm.getLangLabel('LBLADD')"
        @click="addProcess"
      />
      <!-- 직접추가 -->
      <!-- <q-chip
        v-if="editable && !disabled"
        clickable
        square
        color="orange"
        text-color="white"
        icon="add"
        :label="$comm.getLangLabel('LBLADDDIRECTLY')"
        :title="$comm.getLangLabel('LBLADDDIRECTLY')"
        @click="writeProcess"
      /> -->
    </div>
    <div class="col-12">
      <component
        :is="processComponent"
        :assessPlan.sync="assessPlan"
        :process.sync="process"
        :disabled.sync="disabled"
        :updateBtnData.sync="updateBtnData"
        :vendorFlag.sync="vendorFlag"
        @saveProcess="saveProcess"
      />
    </div>
    <q-dialog v-model="processDialog.show" persistent>
      <q-card style="min-width: 350px">
        <q-form ref="editForm">
          <!-- 평가대상 상세 -->
          <c-card title="LBL0001066" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline>
                <c-btn
                  v-show="editable && !disabled"
                  label="LBLSAVE"
                  icon="save"
                  @btnClicked="saveWriteProcess"
                />
                <c-btn
                  label="LBLCLOSE"
                  icon="cancel"
                  @btnClicked="closeDialog"
                />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-12">
                <c-text
                  :editable="editable"
                  :disabled="disabled"
                  label="제조공정"
                  name="processName"
                  v-model="processDialog.processName"
                >
                </c-text>
              </div>
            </template>
          </c-card>
        </q-form>
      </q-card>
    </q-dialog>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from "quasar";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "riskTargetProcess",
  props: {
    assessPlan: {
      type: Object,
      default: () => ({
        ramStepCd: "",
        processes: [], // 대상공정 목록
        ramRiskAssessmentPlanId: "", // 평가 일련번호
        plantCd: "", // 사업장 코드
        ramTechniqueCd: null, // 평가기법 코드_HAZOP/4m/JSA/CHECKLIST
        ramAssessTypeCd: null, // 평가구분_최초/정기/수시
        assessmentName: "", // 평가명
        assessmentStartDate: "", // 평가시작일
        assessmentEndDate: "", // 평가종료일
        assessmentPeriod: [],
        assessmentYear: "", // 평가년도
        assessmentManageDeptCd: "", // 평가주관 부서 코드
        assessmentManageUserId: "", // 평가주관 담당자 ID
        ramMatrixId: null, // 위험메트릭스 번호
        sopMocId: "", // MOC 일련번호
        remark: "", // 상세내용
        workArea: "", // 작업지역
        regUserId: "", // 작성자 ID
        regUserName: "", // 작성자 ID
        regDtStr: "",
        reviewUserId: "", // 검토자 ID
        reviewDate: "", // 검토일
        approvalUserId: "", // 승인자 ID
        approvalDate: "", // 승인일
        vendorCd: "",
        sopConstructionId: "",
        chgUserId: "", // 수정자 ID
        teams: [], // 평가팀 목록
        occasions: [], // 수시 변경/추가 내역 목록
        conferences: [], // 회의 목록
        relatedDocuments: [], // 관련자료 목록
      }),
    },
    searchFlag: {
      type: Object,
      default: () => ({
        value: "",
      }),
    },
    updateBtnData: {
      type: Object,
      default: () => ({
        flag: false,
        research: "",
      }),
    },
    vendorFlag: {
      type: Boolean,
      default: () => ({
        flag: false,
      }),
    },
  },
  data() {
    return {
      process: {
        ramRiskAssessmentPlanId: "", // 평가 일련번호
        processCd: "", // 단위공정 코드
        processName: "", // 단위공정명
        ramProcessAssessStepCd: "", // 평가진행상태
        processExplainFeature: "", // 공정 특징 설명
        assessDeptCd: "", // 평가 부서 코드
        assessDeptName: "",
        assessUserId: "", // 평가 담당자
        assessUserName: "", // 평가 담당자
        workCycleCd: null, // 작업발생주기코드
        workingTime: 0, // 작업시간(1회)
        vendorFlag: 0,
        workMeasurementPlanId: "", // 계획 일련번호
        temperature: "", // 사용온도
        measPlanContent: "",
        workerTypeCd: "",
        shiftFlag: "N",
        workPermitFlag: "N",
        workEduFlag: "N",
        transportTypeCd: null,
        handlingTypeCd: null,
        accidentHistoryFlag: "N",
        accidentHistoryDesc: "",
        nearMissDesc: "",
        heavyTransportTypeCd: "",
        heavyTransportEquip: "",
        heavyManualFlag: "N",
        heavyManualTypeCd: "",
        workEnvMeasureFlag: "N",
        exposureOverFactor: "",
        exposureOverValue: null,
        exposureOverUnit: "",
        specialSafetyEduFlag: "N",
        specialEduTargetCd: "",
        estimationFlag: "", // CHARM 추정 완료여부
        regUserId: "", // 작성자 ID
        chgUserId: "", // 수정자 ID
        equipments: [],
        sops: [],
        drawNodes: [],
        draws: [],
        fmScenarios: [],
        hazopScenarios: [],
        scenarios: [],
        charmResultScenarios: [],
        charmEstimationScenarios: [],
        targets: [],
        thirdScenarios: [],
        safetyInfos: [],
        macinerys: [],
        chemlist: [],
      },
      processDialog: {
        show: false,
        ramRiskAssessmentPlanId: "", // 평가 일련번호
        processCd: "", // 단위공정 코드
        processName: "", // 단위공정명
        ramProcessAssessStepCd: "", // 평가진행상태
        processExplainFeature: "", // 공정 특징 설명
        assessDeptCd: "", // 평가 부서 코드
        assessUserId: "", // 평가 담당자
        workCycleCd: null, // 작업발생주기코드
        workingTime: 0, // 작업시간(1회)
        workMeasurementPlanId: null, // 작업환경측정계획번호
        measPlanContent: null, // 작업환경측정계획번호
        temperature: null, // 공정사용온도
        estimationFlag: "", // CHARM 추정 완료여부
        regUserId: "", // 작성자 ID
      },
      saveProcessCd: "",
      processComponent: () => import(`${"./riskTargetSafetyInfoDetail.vue"}`),
      // tab: 'process',
      // tabItems: [
      //   { name: 'process', icon: 'work_outline', label: '대상공정', component: () => import(`${'./riskTargetProcessDetail.vue'}`) },
      // ],
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "50%",
        param: {},
        closeCallback: null,
      },
      editable: true,
      saveUrl: "",
      deleteUrl: "",
    };
  },
  computed: {
    disabled() {
      return (
        Boolean(
          this.assessPlan.ramStepCd !== "RRS0000001" &&
            this.assessPlan.ramStepCd
        ) && !this.updateBtnData.flag
      );
    },
  },
  watch: {
    "assessPlan.processes": {
      handler: function () {
        let idx = this.$_.findIndex(this.assessPlan.processes, {
          processCd: this.saveProcessCd,
        });
        if (this.saveProcessCd && idx > -1) {
          this.assessPlan.processes[idx].selected2 = true;

          this.assessPlan.processes.forEach((item, index) => {
            if (idx !== index) {
              this.$set(item, "selected2", false);
            }
          });
        }
      },
      deep: true,
    },
    "searchFlag.value": {
      handler: function () {
        if (this.assessPlan.processes && this.assessPlan.processes.length > 0) {
          let idx = this.$_.findIndex(this.assessPlan.processes, {
            processCd: this.saveProcessCd,
          });
          if (idx > -1) {
            // saveProcessCd가 있으면 해당 공정 선택
            this.selectedProcess(true, this.assessPlan.processes[idx], idx);
          } else {
            // saveProcessCd가 없으면 첫 번째 공정 선택
            this.selectedProcess(true, this.assessPlan.processes[0], 0);
          }
        }
      },
      deep: true,
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.saveUrl = transactionConfig.ram.assessProcess.insert.url;
      this.deleteUrl = transactionConfig.ram.assessProcess.delete.url;
      // code setting
      // list setting
      if (this.assessPlan.processes && this.assessPlan.processes.length > 0) {
        this.selectedProcess(true, this.assessPlan.processes[0], 0);
      }
    },
    removeProcess(state, process) {
      // 제외하실 경우 해당 공정에 해당하는\n\r평가대상 목록도 변경됩니다.\n\r진행하시겠습니까?
      let message = "MSG0000383";
      if (this.updateBtnData.flag) {
        // 현재 평가실행 중인 대상공정입니다.\n\r관련되어 있는 정보 및 개선사항, 위험등록부가 같이 삭제됩니다.\n\r진행하시겠습니까?
        message = "MSG0000384";
      }
      window.getApp.$emit("CONFIRM", {
        title: "LBLCONFIRM",
        message: message,
        // TODO : 필요시 추가하세요.
        type: "info", // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.deleteUrl;
          this.$http.type = "DELETE";
          this.$http.param = {
            data: process,
          };
          this.$http.request(() => {
            window.getApp.$emit("APP_REQUEST_SUCCESS");

            // 공정 데이터 명시적 초기화
            Object.assign(this.$data.process, this.$options.data().process);

            this.$emit("saveCallback", this.assessPlan.ramRiskAssessmentPlanId);

            // 삭제 후 첫 번째 공정 선택
            this.$nextTick(() => {
              if (
                this.assessPlan.processes &&
                this.assessPlan.processes.length > 0
              ) {
                this.selectedProcess(true, this.assessPlan.processes[0], 0);
              } else {
                // 남은 공정이 없으면 process 초기화 유지
                this.saveProcessCd = "";
              }
            });

            /**
             * 계획정보수정
             *  변경사항을 적용하기 위함
             */
            if (this.updateBtnData.flag) {
              this.updateBtnData.research = uid();
            }
          });
        },
        // 취소 callback 함수
        cancelCallback: () => {
          process.check = true;
        },
      });
    },
    addProcess() {
      this.popupOptions.title = "공정 검색"; // 단위공정 검색
      this.popupOptions.param = {
        type: "multiple",
        // deptCd: this.assessPlan.assessmentManageDeptCd,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/ram/base/riskProcessPop.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeProcessPopup;
    },
    closeProcessPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let saveData = this.$_.filter(data, (item) => {
          return (
            this.$_.findIndex(this.assessPlan.processes, {
              processCd: item.riskProcessCd,
            }) === -1
          );
        });
        this.$_.forEach(saveData, (item) => {
          item.assessDeptCd = item.deptCd;
          item.assessDeptName = item.deptName;
          item.processCd = item.riskProcessCd;
          item.ramRiskAssessmentPlanId =
            this.assessPlan.ramRiskAssessmentPlanId;
          item.ramProcessAssessStepCd = "RPA0000001";
          // item.assessDeptCd = this.assessPlan.assessmentManageDeptCd;
          item.regUserId = this.$store.getters.user.userId;
          item.ramTechniqueCd = this.assessPlan.ramTechniqueCd;
        });
        this.$http.url = this.saveUrl;
        this.$http.type = "POST";
        this.$http.param = saveData;
        this.$http.request(() => {
          window.getApp.$emit("APP_REQUEST_SUCCESS");
          this.$emit("saveCallback", this.assessPlan.ramRiskAssessmentPlanId);

          /**
           * 계획정보수정
           *  변경사항을 적용하기 위함
           */
          if (this.updateBtnData.flag) {
            this.updateBtnData.research = uid();
          }
        });
      }
    },
    writeProcess() {
      /**
       * 공정을 직접 만들지만, 공정코드를 가상으로 유니크하게 셋팅
       *  :: 해당 테이블 및 이후 테이블에서 공정코드를 사용함으로 이와 같이 구성
       */
      this.processDialog.processCd = "WTE" + uid();
      this.processDialog.show = true;
    },
    closeDialog() {
      this.processDialog.show = false;
      Object.assign(
        this.$data.processDialog,
        this.$options.data().processDialog
      );
    },
    saveWriteProcess() {
      let saveData = [];
      if (
        this.$_.findIndex(this.assessPlan.processes, {
          processName: this.processDialog.processName,
        }) > -1
      ) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSG0000382", // 동일한 공정명이 있습니다.
          type: "warning", // success / info / warning / error
        });
      } else {
        this.processDialog.ramRiskAssessmentPlanId =
          this.assessPlan.ramRiskAssessmentPlanId;
        this.processDialog.ramProcessAssessStepCd = "RPA0000001";
        this.processDialog.regUserId = this.$store.getters.user.userId;
        this.processDialog.assessDeptCd =
          this.assessPlan.assessmentManageDeptCd;
        this.processDialog.ramTechniqueCd = this.assessPlan.ramTechniqueCd;
        saveData.push(this.processDialog);
        this.$http.url = this.saveUrl;
        this.$http.type = "POST";
        this.$http.param = saveData;
        this.$http.request(() => {
          window.getApp.$emit("APP_REQUEST_SUCCESS");
          this.$emit("saveCallback", this.assessPlan.ramRiskAssessmentPlanId);
          this.closeDialog();

          /**
           * 계획정보수정
           *  변경사항을 적용하기 위함
           */
          if (this.updateBtnData.flag) {
            this.updateBtnData.research = uid();
          }
        });
      }
    },
    /**
     * chip 라이브러리 사용
     * 공정을 클릭 했을 시에 해당 공정이 클릭되었음을 표시하게끔 배경색을 변경시키며
     * 다른 공정들은 selected false 처리 및 색상 primary로 변경
     */
    selectedProcess(state, process, idx) {
      if (this.saveProcessCd) {
        this.saveProcessCd = "";
      }
      if (state) {
        this.assessPlan.processes.forEach((item, index) => {
          if (idx !== index) {
            this.$set(item, "selected2", false);
          } else {
            this.$set(item, "selected2", true);
            this.$set(this, "process", process);
          }
        });
      } else {
        this.$set(this.assessPlan.processes[idx], "selected2", true);
      }
    },
    saveProcess(processCd) {
      this.saveProcessCd = processCd;
      this.$emit("saveCallback", this.assessPlan.ramRiskAssessmentPlanId);

      // 저장 후 선택된 공정 재조회
      this.$nextTick(() => {
        let idx = this.$_.findIndex(this.assessPlan.processes, {
          processCd: processCd,
        });
        if (idx > -1) {
          this.selectedProcess(true, this.assessPlan.processes[idx], idx);
        }
      });
    },
  },
};
</script>
